import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  //首页,入口
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/Home')
  },
  //视频页面
  {
    path: '/video',
    name: 'video',
    component: () => import('@/views/Video')
  },
  //登陆
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login')
  },
  //公司详情
  {
    path: '/company/:id',
    name: 'company',
    component: () => import('@/views/Company')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to,from,next) => {
  // if(!localStorage.getItem('loginUserInfo')) {
  //   if(to.name != 'login') {
	//   localStorage.clear();		
  //     next('/login');
  //   }else {
  //     next();
  //   }
  // }else {
    next();
  //}
})
export default router
